export default "__VITE_ASSET__BcDZNXQL__"